import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import "./otp.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { generatePhoneOtp, resetOtpState,verifyPhoneOtp} from "../../redux/slices/otpSlice";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const OTPVerifier = () => {
const location =useLocation(); 
const memberType = location.state?.member_type;
// console.log("target the Member Type---->",memberType); 
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(30);
  const [resendDisabled, setResendDisabled] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.otp);

    useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  const sendOTP = async () => {
    if (mobile.length !== 10) {
      alert("Enter a valid 10-digit mobile number.");
      return;
      }
       const result = await dispatch(generatePhoneOtp({ phone: mobile, member_type: memberType }));
        if (generatePhoneOtp.fulfilled.match(result)) {
        const response = result.payload;
        console.log("otp----->",response)
       if (response.error === 0) {
        setOtpSent(true);
        setTimer(30);
        setResendDisabled(true);
        toast.success(`your otp is ${response.otp}`,);
      } else {
        toast.error(response.msg || "Failed to send OTP");
      }
      } else {
      toast.error(result.payload || "Failed to send OTP");
         }
        };
      const verifyOTPHandler = async() => {
      if (otp.length !== 6) {
      alert("Please enter the 6-digit OTP");
      return;
    }

  const result = await dispatch(verifyPhoneOtp({ phone: mobile, otp }));
  if (verifyPhoneOtp.fulfilled.match(result)) {
    const data = result.payload;
    console.log("✅ Verified OTP Response Data:", data.user);
    if (data.error === 0) {
      toast.success("OTP Verified Successfully!");
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      if (memberType === 2) {
        if (data.user?.member_active === 3) {
          navigate("/prevstatus");
        } else {
          navigate("/gstpage");
        }
      } else if (memberType === 4) {
        navigate("/merchantPage");
      } else {
        toast.error("Invalid member type.");
      }
    } else {
      toast.error(data.msg || "Verification failed");
    }
  } else {
    toast.error(result.payload || "Verification failed");
  }
}
    return (
    <div className="bg-image">
      <div className="root_box_otp">
        <div className="sub_box">
          {!otpSent ? (
            <>
          <div className="otp_gif">
          <DotLottieReact
          src="https://lottie.host/8c0d398e-ff8f-4351-9651-29af6ade0cdb/3pyoP3hBUg.lottie"
          autoplay
          style={{ width: "110px", height: "110px" }}/>
              </div>
              <h2 style={{ color: "#007bff", fontSize: "25px", marginTop: "10px" }}>
                OTP Verifier
              </h2>
              <p>Enter your mobile number</p>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <input
                  className="form-control mobilenumber_input"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  placeholder="+91 Mobile Number"
                  value={mobile}
                  onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setMobile(onlyNums);
                }}
                  maxLength={10}
                  style={{ padding: "10px", fontSize: "16px", width: "60%" }}
                />
              </div>
              <br />
              <br />
              <button
                onClick={sendOTP}
                type="button"
                className="btn btn-primary"
                disabled={loading}>
                {loading ? "Sending..." : "Send OTP"}
              </button>
            </>
          ) : (
            <>
              <div className="otp_gif">
                <DotLottieReact
                  src="https://lottie.host/a56c3d24-ee15-4bc9-96df-0c0c5571d33c/nOneqL5EAC.lottie"
                  loop
                  autoplay
                  style={{ width: "110px", height: "110px" }}
                />
              </div>
              <h2 style={{ color: "#007bff", fontSize: "25px", marginTop: "10px" }}>
                Verification Code
              </h2>
              <p>Please type the verification code sent to</p>
              <p style={{ fontWeight: "500", marginTop: "-10px" }}>+91 {mobile}</p>

              <div className="otp_input_box">
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  shouldAutoFocus
                  renderSeparator={<span></span>}
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        width: "40px",
                        height: "40px",
                        margin: "5px",
                        fontSize: "20px",
                        textAlign: "center",
                        backgroundColor: "#d7dbdd",
                        color: "#273746",
                        border: "none",
                        outline: "none",
                        borderRadius: "5px",
                      }}
                      onFocus={(e) => {
                        e.target.style.backgroundColor = "white";
                        e.target.style.border = "2px solid #007bff";
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "#d7dbdd";
                        e.target.style.border = "none";
                      }}
                    />
                  )}
                />
              </div>
              <br />
              <button onClick={verifyOTPHandler} type="button" className="btn btn-primary">
                Verify OTP
              </button>
              {resendDisabled ? (
                <p className="otp_timmer">
                  Resend OTP in <b>{timer}s</b>
                </p>
                ) : (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={sendOTP}>
                  Resend OTP
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OTPVerifier;
